export function useSafeFormFieldUpdater<T>(setState: React.Dispatch<React.SetStateAction<T>>) {
  return (fieldPath: string, value: any) => {
    setState((prev: any) => {
      if (!prev) return prev;
 
      const updated = structuredClone(prev);
      const parts = fieldPath.split(".");
      let current = updated;
      let prevValue = prev;
 
      for (let i = 0; i < parts.length - 1; i++) {
        const key = parts[i];
        prevValue = prevValue?.[key];
        if (!(key in current)) current[key] = {};
        current = current[key];
      }
 
      const lastKey = parts[parts.length - 1];
 
      if (prevValue?.[lastKey] === value) {
        return prev; // Skip if value is the same, prevents infinite renders
      }
 
      current[lastKey] = value;
      return updated;
    });
  };
}